// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1MDUG","file":"styles_file__JCvC_"};